package com.appsyde.shared.modules.team.data.source

import com.appsyde.shared.modules.team.data.InviteListItemDto
import com.appsyde.shared.modules.team.data.UserListItemDto

interface TeamRemoteDataSource {
    suspend fun getUsers(): List<UserListItemDto>
    suspend fun getInvites(): List<InviteListItemDto>
    suspend fun createInvite(email: String): CreateInviteResult
    suspend fun revokeInvite(inviteId: String): Boolean
    suspend fun disableUser(userId: String): Boolean
}

sealed class CreateInviteResult {
    data class Ok(val inviteId: String) : CreateInviteResult()
    data object InvalidEmail : CreateInviteResult()
    data object CannotInviteOwner : CreateInviteResult()
    data object AlreadyMember : CreateInviteResult()
    data class Error(val message: String?) : CreateInviteResult()
}
